require('./expensesByCategoryMonthly.scss');

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getLanguage } = require('core/i18n').i18n;

//@components
const OKAccelerometerMonthlyChart = require('components/charts/OKAccelerometerMonthlyChart/OKAccelerometerMonthlyChart');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @images
const openTutorialImg = require('assets/images/icon-tutorial.svg');

class ExpensesByCategoryMonthly extends React.Component {
    constructor(props) {
        super(props);

        this.drawIcon = this.drawIcon.bind(this);
    }

    drawIcon() {
        const { monthlyValue, currency, totalExpenses } = this.props;
        const currentMonth =  moment().format('MMMM').toLowerCase();
        const currentDay = moment().format('DD');
        
        return (
            <div>
                <div className="col-xs-12 col-md-12 expenses-monthly__no-padding">
                    <h3 className="expenses-monthly__title">
                        <FormattedText value="monthlyExpenses-title" />
                    </h3>
                </div>
                <div className="col-xs-12 col-md-12 expenses-monthly__no-padding">
                    <span className="expenses-monthly__title-date">{
                        formatText('monthlyExpenses-date', [currentDay,currentMonth])
                    }</span>
                </div>
                <div className="col-xs-12 col-md-12 expenses-monthly__no-padding expenses-monthly__total-container">
                    <span className="expenses-monthly__top-title-total"><FormattedText value="monthlyExpenses-total" /></span>
                    <span className="expenses-monthly__title-total-expenses">
                        <OneLineSymbolAmount
                            language={getLanguage()}
                            positiveAmount
                            amountObject={{amount: totalExpenses, currencySymbol: currency}}
                            amountObjectFormatted={{currencySymbol: currency}}
                        />
                    </span>
                </div>
                <OKAccelerometerMonthlyChart monthlyValue={monthlyValue} />
            </div>
        )
    }

    render() {
        const { monthlyValue, loading } = this.props;
        const tooltipTarget = (
            <img
                src={openTutorialImg}
                className="expenses-monthly__tooltip-element"
            />
        );

        let message = "lessMessage";
        if (-0.5 < monthlyValue) {
            message = monthlyValue >= 0.5 ? 'moreMessage' : 'sameMessage' ;
        }
        return (
            <div className="expenses-monthly">
                {loading && <div className="expenses-monthly__loading"><LoadingSection center={true} /></div>}
                {this.drawIcon()}
                <div className="col-xs-12 col-md-12 expenses-monthly__no-padding expenses-monthly__container-message">
                    <span className="expenses-monthly__message">
                        <FormattedText value={`monthlyExpenses-${message}`} />
                        <OKTooltip
                            content="monthlyExpenses-textTooltip"
                            modifier="dark-bg"
                            offset={[-70, 10]}
                            placement="bottom"
                            target={tooltipTarget}
                        />
                    </span>
                </div>
                <div className="col-xs-12 col-md-12 expenses-monthly__no-padding expenses-monthly__container-legend">
                    <p className="expenses-monthly__legend-good col-lg-12 col-md-4 col-sm-12"><FormattedText value="monthlyExpenses-legendGood" /></p>
                    <p className="expenses-monthly__legend-same col-lg-12 col-md-4 col-sm-12"><FormattedText value="monthlyExpenses-legendSame" /></p>
                    <p className="expenses-monthly__legend-bad  col-lg-12 col-md-4 col-sm-12"><FormattedText value="monthlyExpenses-legendBad" /></p>
                </div>
            </div>
        );
    }
}

ExpensesByCategoryMonthly.propTypes = {
    monthlyValue: PropTypes.number,
    totalExpenses: PropTypes.number,
    currency: PropTypes.string,
    loading: PropTypes.bool
};

module.exports = { ExpensesByCategoryMonthly };
